"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilteredData = void 0;
var react_1 = require("react");
var date_fns_1 = require("date-fns");
var useFilteredData = function (_a) {
    var data = _a.data, dates = _a.dates, status = _a.status, type = _a.type;
    return (0, react_1.useMemo)(function () {
        if (data)
            return data === null || data === void 0 ? void 0 : data.filter(function (row) {
                var from = dates.from, to = dates.to;
                if (status !== null && (status === null || status === void 0 ? void 0 : status.value) !== 'all') {
                    if (status.value !== null && status.value !== row.status)
                        return false;
                }
                if (type !== null && (type === null || type === void 0 ? void 0 : type.value) !== 'all') {
                    if (type.value !== null && type.value !== row.type)
                        return false;
                }
                if (from && to && from < to) {
                    var dateFormat = 'dd-LL-yy';
                    var fromDate = (0, date_fns_1.format)(new Date(from), dateFormat);
                    var rowDate = (0, date_fns_1.format)(new Date(row.createdAt), dateFormat);
                    var toDate = (0, date_fns_1.format)(new Date(to), dateFormat);
                    var nowDate = new Date();
                    return (0, date_fns_1.isWithinInterval)((0, date_fns_1.parse)(rowDate, dateFormat, nowDate), {
                        start: (0, date_fns_1.parse)(fromDate, dateFormat, nowDate),
                        end: (0, date_fns_1.parse)(toDate, dateFormat, nowDate),
                    });
                }
                return true;
            });
        return [];
    }, [type, data, dates, status]);
};
exports.useFilteredData = useFilteredData;
